module.exports = __webpack_public_path__ + "img/fyt_p9.b87a8d07.png";